import { Link, useRouterState } from "@tanstack/react-router";
import { Icon } from "@/components/ui/Icon";

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

const navItems: NavItem[] = [
  {
    path: "/clubs",
    label: "Clubs",
    icon: "globe",
  },
  {
    path: "/events",
    label: "Events",
    icon: "calendar",
  },
  // {
  //   path: "/scenes",
  //   label: "Scenes",
  //   icon: "circles",
  // },
];

export function MobileNav() {
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border-tertiary safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive = currentPath.startsWith(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors ${
                isActive
                  ? "text-accent-secondary"
                  : "text-text-tertiary hover:text-text-secondary"
              }`}
            >
              <Icon name={item.icon} size={22} />
              <span className="text-body-3">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
